// extracted by mini-css-extract-plugin
export default {"container":"dHxq6K","input":"jlTEzp","switcher":"cuo2PC mz-switch","disabled":"br6C6V","on":"jCA1HY mz-switch--on","label":"ynMKWc","verbose":"lWdOCF"};